import React, { Component } from 'react';
import Search from '../Home/Search';
import '../../../src/styles/ShoppingCart.css';
import '../../../src/styles/open-iconic.css';
import '../../../src/styles/open-iconic-bootstrap.css';
import { Collapse } from 'react-bootstrap';
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import { appService } from '../../_services'
import { faIR } from 'date-fns/esm/locale';
import DocumentMeta from 'react-document-meta';
import { Accordion } from 'react-bootstrap';
import { Card } from 'react-bootstrap';
import { FaChevronUp } from 'react-icons/fa';
import { FaChevronDown } from 'react-icons/fa';
import ReactGA from 'react-ga';
import { Link } from 'react-router-dom';
import EmailModal from 'react-bootstrap/Modal';
var CountAC = 0, CountHK = 0, CountLQ = 0, CountRZ = 0, CountDG = 0;
let options1 = '', options2 = '', Itemid = '', parameters = ""
var setpadding = { paddingLeft: '8%' }

var cardbodystyle = {
    border: '1px solid #CCCCCC',
    height: '300px',
    overflowY: 'scroll'
}
export class ManageEtoc extends Component {
    displayName = ManageEtoc.name
    constructor(props) {
        super(props);

        this.state = {
            showgeneral: false,
            ShowUp1: false
        };
        this.state = {
            checked: false,
            productList: [],
            productDtlList: [],
            ShowSublist: [],
            ShowSublistRange: [],
            countries: [],
            type: '',
            checkedTearm: '',
            selectCount: '',
            practicAreaCount: 0,
            practicAreaCountRangeCount: 0,
            user: {
                ContactName: '',
                Email: '',
                iAgree: false,
                TitleError: ''
            },
            errors: {}
        }


        this.CheckboxClick = this.CheckboxClick.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleCheck = this.handleCheck.bind(this);
        this.SearchEtocDetails = this.SearchEtocDetails.bind(this);
        this.SearchDataPracticArea = this.SearchDataPracticArea.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.ClearAll = this.ClearAll.bind(this);
        this.handleEmailModalShow = this.handleEmailModalShow.bind(this);
        this.handleEmailModalClose = this.handleEmailModalClose.bind(this);
    }

    handleEmailModalClose() {
        this.setState({ handleEmailModalShow: false });
    }

    handleEmailModalShow() {
        this.setState({ handleEmailModalShow: true });
    }

    ClearAll() {
        //console.log(this.state.productList);
        this.state.productList.forEach(item => {
            item[0].isChecked = false;

        })

        this.setState({
            productList: this.state.productList
        })

        this.setState({
            practicAreaCount: 0
        })

    }

    handleInputChange(event) {

        const { name, value } = event.target;
        const { user } = this.state;
        this.setState({
            user: {
                ...user,
                [name]: value
            }
        });
    }

    componentDidMount() {
        var self = this;
        appService.getAll('Product/GetAllProductDetails').then(function (data) {
            {
                data.map((item, index) => (
                    options1 = self.state.productList,
                    options1.push(item.productViewModel),

                    self.setState({
                        productList: options1,
                        ItemsPA: options1
                    })
                ))
            }
        });

        appService.getAll('Cart/GetAllCountries').then(function (response) {
            self.setState({
                countries: response
            });
        });

        ReactGA.initialize(
            [
                {
                    trackingId: 'UA-2905701-8',
                    gaOptions: { name: 'tracker1' }
                },
                {
                    trackingId: 'UA-72849501-2',
                    gaOptions: { name: 'tracker2' }
                }
            ],
            { alwaysSendToDefaultTracker: false }
        );

        ReactGA.pageview(window.location.pathname, ['tracker1', 'tracker2'], "ETOC - Kluwer Law Online");
        

    }

    componentWillMount() {
        this.setState({ ItemsPA: this.state.productList })
        this.setState({ ItemsAC: this.state.RangeAToC })
        this.setState({ ItemsDG: this.state.RangeDToG })
        this.setState({ ItemsHK: this.state.RangeHToK })
        this.setState({ ItemsLQ: this.state.RangeLToQ })
        this.setState({ ItemsRZ: this.state.RangeRToZ })

    }

    CheckboxClick(evt) {
        var count = 0;
        let list = this.state.productList;
        list.forEach(item => {
            if (item[0].id == evt.target.value) {
                Itemid = item[0].id;
                item[0].isChecked = evt.target.checked;
            }

            if (item[0].isChecked == true) {
                count++;
            }

        });
        this.setState({
            productList: list
        })

        this.setState({
            practicAreaCount: count
        })

        this.setState({
            ShowPAClearAll: true
        })

    }


    SearchEtocDetails(e) {
        var searchTextBox = e.target.id;
        this.SearchDataPracticArea(e);
    }


    SearchDataPracticArea(e) {

        if (e.target.value !== '') {
            var updatedList = this.state.productList;
            updatedList = updatedList.filter(function (item) {
                return item[0].title.toLowerCase().search(
                    e.target.value.toLowerCase()) !== -1;
            });
            this.setState({ ItemsPA: updatedList });
        }

    }

    handleCheck(evt) {
        this.setState({ checked: !this.state.checked });

        const { user } = this.state;
        this.setState({
            user: {
                ...user,
                iAgree: evt.target.checked
            }
        });
    }


    validateForm() {

        let fields = this.state.user;
        let errors = {};
        let formIsValid = true; let CheckFlag = false;

        if (!fields["ContactName"]) {
            formIsValid = false;
            errors["ContactName"] = "* Required field";
        }
        else if (typeof fields["ContactName"] !== "undefined") {
            if (!fields["ContactName"].match(/^[a-zA-Z ]*$/)) {
                formIsValid = false;
                errors["ContactName"] = "Please enter alphabet characters only.";
            }
        }

        this.state.productList.map(Pdtldtl => {
            if (Pdtldtl[0].isChecked == true) {
                CheckFlag = true;
                formIsValid = true;
            }
        })

        if (CheckFlag == false) {
            formIsValid = false;
            errors["TitleError"] = "* Please select at least one title";
        }


        if (!fields["Email"]) {
            formIsValid = false;
            errors["Email"] = "* Required field";
        }

        else if (typeof fields["Email"] !== "") {
            //regular expression for email validation
            var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
            if (!pattern.test(fields["Email"])) {
                formIsValid = false;
                errors["Email"] = "* Please enter a valid email address";
            }
        }

        if (!fields["iAgree"]) {
            formIsValid = false;
            errors["iAgree"] = "* Permission required to send message";
        }

        this.setState({
            errors: errors
        });
        return formIsValid;

    }

    handleSubmit(e) {
        if (this.validateForm()) {
            var checkTab = this.state.TABChange;
            var modelData = [];
            var data = [];
            var EtocDetailsPost = [];

            this.state.productList.map(Pdtldtl => {
                if (Pdtldtl[0].isChecked == true) {
                    data.push({ Id: Pdtldtl[0].id, isChecked: Pdtldtl[0].isChecked, Title: Pdtldtl[0].title });
                }
            })


            var contactname = this.refs["contactname"].value;

            var Email = this.refs["Email"].value;

            var radioValue = this.state.type;
            var cheboxValue = '';
            if (this.state.checked) {
                cheboxValue = true
            } else {
                cheboxValue = false;
            }

            parameters = {
                Email: Email,
                Name: contactname,
                ProductDetailsList: data
            }

            appService.submit('/Email/SendETOCEmail', parameters)
                .then(function (data) {
                    if (data == "") {

                    }
                });


            EtocDetailsPost.push({ Name: contactname, Position: '', Email: Email, CountryId: 1, TypeOfBusiness: '', PreferredFormat: '', DoNotSend: cheboxValue });
            modelData.push({ EtocDetailsPostModel: EtocDetailsPost[0], ProductList: data });
            appService.getByIssueId('Product/SubmitETOCRequest', modelData)
                .then(function (data) {
                    if (data == "Success") {
                        window.scrollTo(0, 0);
                        window.location.href = "/EtocSuccess"
                    }
                });



        }
    }

    renderList = () => {
        return this.state.ItemsPA.map(item =>
            <li key={item[0].id} style={{ listStyle: 'none' }}>
                <div className="form-group" key={item[0].id}>
                    <div className="square">
                        <input type="checkbox" id={item[0].id}
                            name={item[0].title} value={item[0].id} checked={item[0].isChecked} onChange={this.CheckboxClick} />
                        <label htmlFor={item[0].id}></label>
                        <span className="LinkClass" style={setpadding}> {item[0].title}</span>
                    </div>

                    {(() => {
                        if (this.state.ShowSublist.length > 0) {

                            return (

                                this.state.ShowSublist.map(Subitem =>

                                    <div key={Subitem}>

                                        {(() => {

                                            if (Subitem == item[0].id) {
                                                return (
                                                    this.state.productDtlList.map(Pdtldtl =>
                                                        Pdtldtl.map(SubListItem =>
                                                            <div key={SubListItem.id}>

                                                                {(() => {

                                                                    if (SubListItem.productId == item[0].id && SubListItem.articleTitle !== '')

                                                                        return (
                                                                            <div style={{ paddingLeft: '25px', paddingTop: '1%' }} key={SubListItem.articleTitle}>

                                                                                <div className="square">
                                                                                    <input checked={SubListItem.isChecked} type="checkbox" id={item[0].id + "_" + SubListItem.id}
                                                                                        name={item[0].id + "_" + SubListItem.id} value={item[0].id + "_" + SubListItem.id}
                                                                                        onChange={this.SubitemChangeClick} />
                                                                                    <label htmlFor={item[0].id + "_" + SubListItem.id}></label>
                                                                                    <span style={{ paddingLeft: '5%', fontSize: '12px' }} dangerouslySetInnerHTML={{ __html: SubListItem.articleTitle }}></span>
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                }
                                                                )()}
                                                            </div>
                                                        ))
                                                )
                                            }
                                        }
                                        )()}

                                    </div>
                                )

                            )

                        }

                        else {
                            return (
                                this.state.showgeneral ?
                                    this.state.productDtlList.map(Pdtldtl =>
                                        Pdtldtl.map(Subitem =>
                                            <div key={Subitem.id}>
                                                {(() => {
                                                    if (Subitem.productId == item[0].id && Subitem.articleTitle !== '')
                                                        return (
                                                            <div style={{ paddingLeft: '25px', paddingTop: '1%' }} key={Subitem.articleTitle}>

                                                                <div className="square">
                                                                    <input checked={Subitem.isChecked} type="checkbox" id={item[0].id + "_" + Subitem.id}
                                                                        name={item[0].id + "_" + Subitem.id} value={item[0].id + "_" + Subitem.id}
                                                                        onChange={this.SubitemChangeClick} />
                                                                    <label htmlFor={item[0].id + "_" + Subitem.id} ></label>
                                                                    <span style={{ paddingLeft: '5%', fontSize: '12px' }} dangerouslySetInnerHTML={{ __html: Subitem.articleTitle }}></span>
                                                                </div>
                                                            </div>
                                                        )

                                                    else {
                                                        return (
                                                            <div ></div>
                                                        )
                                                    }
                                                }
                                                )()}
                                            </div>
                                        ))

                                    : null
                            )
                        }

                    }
                    )()}
                </div>
            </li>
        )
    }



    render() {

        const Title1 = <span> Practice area  <span className="badge" style={{ marginLeft: '5px', borderRadius: '6px', padding: '5px 10px' }}>{this.state.practicAreaCount != 0 ? this.state.practicAreaCount : null}</span> </span>
        const Title2 = <span> A-Z  <span className="badge" style={{ marginLeft: '5px', borderRadius: '6px', padding: '5px 10px' }}>{this.state.practicAreaCountRangeCount != 0 ? this.state.practicAreaCountRangeCount : null}</span> </span>

        const meta = {
            title: "Kluwer Law Online - Etoc",
            canonical: window.location.href,
        }

        return (
            <DocumentMeta {...meta}>
                <div>
                    <div className="col-12">
                        <div className="row">
                            <div className="col-lg-9">
                                <p className="TitlePadding Title"> Manage Table of contents alert (ETOC)</p>
                                <p className="TitlePadding BookBody">Add/remove the title(s) you wish to subscribed to.</p>
                                <p className="TitlePadding BookBody"><Link to="/" className="LinkClass">Change Email address or password</Link></p>
                                <p className="TitlePadding BookBody LinkClass" onClick={this.handleEmailModalShow} style={{ cursor: 'pointer' }}>Delete eTOC account</p>
                                <span className="TitlePadding green-heading" style={{ fontSize: '18px' }}>Add/remove titles of interest</span>
                            </div>
                        </div>

                        <EmailModal show={this.state.handleEmailModalShow} onHide={this.handleEmailModalClose}  {...this.props}
                            size="lg"
                            aria-labelledby="contained-modal-title-vcenter"
                            centered>
                            <EmailModal.Header closeButton className="Popupcolor">
                                <EmailModal.Title>
                                    Delete eTOC account
                                            </EmailModal.Title>
                            </EmailModal.Header>
                            <EmailModal.Body>
                                <div>
                                    <div className="row mt-3 AllColPadding">
                                        <div className="col-lg-8 TopicPadding">
                                            <p>Your eTOC account will be deleted and you will not receive any further eTOC e-mails in your inbox.</p>
                                        </div>
                                    </div>

                                </div>
                            </EmailModal.Body>
                            <EmailModal.Footer>
                                <div className="row AllColPadding">
                                    <div className="col-sm-8 TopicPadding">
                                        <button variant="primary" className="btn btn-info next FloatSet">
                                            Confirm
                                    </button></div>
                                    <div className="col-sm-4 TopicPadding ">
                                        <span variant="secondary" className="Modalbutton HoverUnderline"> Cancel </span>
                                    </div>
                                </div>
                            </EmailModal.Footer>
                        </EmailModal>

                        <br></br>
                        <br></br>
                        <div className="row">
                            <div className="TitlePadding col-lg-6">
                                <Accordion defaultActiveKey="0" >
                                    <Card className="cardBorderZero">
                                        <Card.Header className="panel-heading">
                                            <Accordion.Toggle as={Card.Header} eventKey="0" className="cardmargin" style={{ border: '0px' }} onClick={() => this.setState({ ShowUp1: !this.state.ShowUp1 })}>
                                                <h5 style={{ fontSize: '16px', height: '35px', padding: '11px 15px', color: '#474747', marginBottom: '1%', marginTop: '0.5%' }}>Titles ({this.state.practicAreaCount})
                                                     <label style={{ fontSize: '16px', color: '#007AC3', float: 'right', paddingRight: '5%' }} onClick={this.ClearAll}>Clear</label>
                                                </h5>
                                                <Collapse in={!this.state.ShowUp1}>
                                                    <span className="pull-right clickable" onClick={() => this.setState({ ShowUp1: !this.state.ShowUp1 })}><FaChevronUp /></span>
                                                </Collapse>
                                                <Collapse in={this.state.ShowUp1}>
                                                    <span className="pull-right clickable" onClick={() => this.setState({ ShowUp1: !this.state.ShowUp1 })}><FaChevronDown /></span>
                                                </Collapse>
                                            </Accordion.Toggle>
                                        </Card.Header>
                                        <Accordion.Collapse eventKey="0">
                                            <Card.Body style={cardbodystyle}>
                                                <br></br>
                                                <div className="col-lg-7">
                                                    <input className="form-control BookBody" id="txtSearchBox" type="text" onChange={this.SearchEtocDetails} placeholder="Enter first few letters of title name" />
                                                </div>
                                                <br></br>
                                                <div className="col-lg-8">
                                                    {this.renderList()}
                                                </div>
                                            </Card.Body>
                                        </Accordion.Collapse>
                                    </Card>
                                </Accordion>
                                <span className="errorMsg">{this.state.errors.TitleError}</span>
                            </div>

                        </div>
                        <br></br>
                        <div className="row">
                            <div className="col-lg-4 TitlePadding">
                                <p className="BookBody">Preferred format </p>
                            </div>
                        </div>
                        <div className="row TitlePadding">
                            <div className="custom-control custom-radio col-lg-1">
                                <label className="radiocontainer"><input type="radio" ref="HTML" name="HTML" checked />
                                    <span className="checkRadiomark"></span></label>
                                HTML
                        </div>
                            <div className="custom-control custom-radio col-lg-2">
                                <label className="radiocontainer"> <input type="radio" ref="Text" name="radio" />
                                    <span className="checkRadiomark"></span>
                                </label>
                                Text
                        </div>
                        </div>
                        <br></br>
                        <div className="row TitlePadding">
                            <div className="square" style={{ width: '100%' }}>
                                <input type="checkbox" id="terms" onChange={this.handleCheck} Checked={this.state.checked} />
                                <label for="terms"></label>
                                <span className="EtocPad" style={{ paddingLeft: '3%' }}>I agree to the storage of my email address and name {this.state.user.ContactName != '' ? "[" + this.state.user.ContactName + "]" : ''} for the purpose of receiving ETOC alerts.</span>
                                <br />
                                <span className="EtocPad" style={{ paddingLeft: '3%' }}>For further privacy details <a target="_blank" href="http://www.kluwerlaw.com/gdpr/" target="_blank" Tdata-tooltip="Personal data processing info">click here</a>.</span>
                                &nbsp;&nbsp;&nbsp;&nbsp; <span className="errorMsg" style={{ float: 'none' }}>{this.state.errors.iAgree}</span>
                            </div>

                        </div>
                        <br></br>
                        <div className="row TitlePadding">
                            <button type="button" onClick={this.handleSubmit} className="btn btn-info next rounded-0">Submit ETOC request</button>
                        </div>
                        <div className="White">
                        </div>
                        <div className="White">
                        </div>
                    </div >
                </div>
            </DocumentMeta>
        );
    }
}
export default ManageEtoc;


// WEBPACK FOOTER //
// ./src/components/ETOC Accounts/ManageEtoc.jsx